import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EyeInvisibleTwoTone } from '@ant-design/icons';
import { PricelessTag } from 'pages/UniversalProductsPage/ProductsPage/PricelessFilterToggle.styled';
import { theme } from 'styles';
import { DashedButton } from 'UI/Button/DashedButton';

export interface PricelessFilterToggleProps {
  showPriceless: boolean;
  pricelessCount: number;
  onToggle: () => void;
}

const PricelessIcon = memo(() => <EyeInvisibleTwoTone twoToneColor={[theme.color.grey10, theme.color.grey85]} />);
PricelessIcon.displayName = 'PricelessIcon';

const PricelessFilterToggleComponent = ({ showPriceless, pricelessCount, onToggle }: PricelessFilterToggleProps) => {
  const { t } = useTranslation();
  const iconLeft = useMemo(() => <PricelessIcon />, []);

  return (
    <DashedButton
      isActive={showPriceless}
      iconLeft={iconLeft}
      iconRight={<PricelessTag>{pricelessCount}</PricelessTag>}
      onClick={onToggle}
      data-cy={'priceless-filter-toggle-button'}
    >
      {showPriceless
        ? t('catalog.universal_products.filter.hide_priceless', 'Hide {{count}} product(s) without price', {
            count: pricelessCount,
          })
        : t('catalog.universal_products.filter.show_priceless', 'Show {{count}} product(s) without price', {
            count: pricelessCount,
          })}
    </DashedButton>
  );
};

export const PricelessFilterToggle = memo(PricelessFilterToggleComponent);
